const buildPrintDocument = (doc, { imageSrc, fileName, rotation }) => {
  doc.open();
  doc.write("<!DOCTYPE html><html><head></head><body></body></html>");
  doc.close();

  doc.title = fileName;

  const style = doc.createElement("style");
  style.textContent = `
    @page {
      margin: 12mm;
    }
    body {
      margin: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 100vh;
    }
    img {
      max-width: 100%;
      max-height: 100vh;
      object-fit: contain;
      transform: rotate(${rotation}deg);
      transform-origin: center center;
    }
  `;
  doc.head.appendChild(style);

  const img = doc.createElement("img");
  img.alt = fileName;
  img.src = imageSrc;
  doc.body.appendChild(img);

  return img;
};

export const printImage = ({ src, fileName = "Image", rotation = 0 }) => {
  if (!src) {
    return Promise.resolve(false);
  }

  const iframe = document.createElement("iframe");
  iframe.setAttribute("aria-hidden", "true");
  iframe.style.cssText =
    "position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden";
  document.body.appendChild(iframe);

  const printWindow = iframe.contentWindow;
  if (!printWindow) {
    document.body.removeChild(iframe);
    return Promise.resolve(false);
  }

  const doc = printWindow.document;
  const img = buildPrintDocument(doc, {
    imageSrc: src,
    fileName,
    rotation,
  });

  return new Promise((resolve) => {
    let finished = false;

    const cleanup = () => {
      if (iframe.parentNode) {
        document.body.removeChild(iframe);
      }
    };

    const fail = () => {
      if (finished) {
        return;
      }
      finished = true;
      cleanup();
      resolve(false);
    };

    const startPrint = () => {
      if (finished) {
        return;
      }
      finished = true;
      printWindow.focus();
      printWindow.print();
      resolve(true);
    };

    img.onload = startPrint;
    img.onerror = fail;

    printWindow.onafterprint = cleanup;

    if (img.complete) {
      if (img.naturalWidth > 0) {
        startPrint();
      } else {
        fail();
      }
    }
  });
};
